import React, { useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
} from "reactstrap"
import { AvForm } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import SalesRepsService from "services/Admin/SalesRepsService"
import SelectOptions from "components/SelectOptions"
import DealService from "services/Admin/DealService";

function AssignSalesRepModal({ modal, toggle, idsSelected,setShouldGetData }) {
    const dealService = new DealService()
    const [loading, setLoading] = useState(false)
    const [salesRepOptions, setSalesRepOptions] = useState([])
    const [formData, setFormData] = useState({
        sales_rep_id: null,
    })

    const handleValidSubmit = (_, values) => {
        if (!formData.sales_rep_id) {
            toast.error("Please Select Sales Rep")
            return
        } else {
            setLoading(true)
            const data = {
                sales_rep_id: formData.sales_rep_id.value,
                deal_ids : idsSelected ,
            }
            dealService.updateMultiDeals(data).then(res=>{
                if(res.status){
                    toast.success("Sales Rep Assigned Successffuly")
                    setShouldGetData(true)
                    toggle()
                }else{
                    setLoading(false)
                }
            })
        }
    }
    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <AvForm
                className='form-horizontal'
                onValidSubmit={(e, v) => {
                    handleValidSubmit(e, v)
                }}>

                <ModalBody>
                    <Row>
                        <Row className="my-0 p-1 d-flex justify-content-between">
                            <Col><span className="font-size-15 fw-bold">Assign Sales Rep </span></Col>
                        </Row>
                    </Row>
                    <hr />
                    <Row>
                        <Col md={12}>
                            <SelectOptions
                                label='Sales Rep'
                                placeholder='Select'
                                options={salesRepOptions}
                                handleSelectChange={(data) => {
                                    setFormData({ ...formData, sales_rep_id: data });
                                }}
                                selectedOption={formData.sales_rep_id}
                                Service={SalesRepsService}
                                setOptions={(options) => {
                                    setSalesRepOptions(options)
                                }}
                            />
                        </Col>
                    </Row>


                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-between">
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-secondary'>
                        Cancel
                        </button>
                    <button
                        type='submit'
                        disabled={loading ? true : false}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </AvForm>
        </Modal>

    )
}

export default AssignSalesRepModal
